// extracted by mini-css-extract-plugin
export default {"label":"DropZone_label__kARUS","labelBold":"DropZone_labelBold__VwsEz","helperText":"DropZone_helperText__wnjV3","uploadIcon":"DropZone_uploadIcon__h-UFr"};